import portfolioImg01 from "../images/portfolio-01.png";
import portfolioImg02 from "../images/portfolio-02.png";
import portfolioImg03 from "../images/portfolio-03.png";
import portfolioImg04 from "../images/portfolio-04.png";
import portfolioImg05 from "../images/portfolio-05.png";
import portfolioImg06 from "../images/portfolio-06.png";
import portfolioImg07 from "../images/portfolio-07.png";
import portfolioImg08 from "../images/portfolio-08.png";
import portfolioImg09 from "../images/portfolio-09.png";
import portfolioImg10 from "../images/portfolio-10.png";
import portfolioImg11 from "../images/portfolio-11.png";
import portfolioImg12 from "../images/portfolio-12.png";

const portfolios = [
  {
    id: "12",
    imgUrl: portfolioImg12,
    category: "Web/App Dev",
    title: "Doctor Appointment Booking - On Progress",
    description:
      "This website connects patients with doctors. Patients can book doctors according to their needs.",
    technologies: ["Node.js", "React", "Tailwind css", "MongoDB"],
    siteUrl: "https://doctor-appointment-booking-client.vercel.app",
  },
  {
    id: "11",
    imgUrl: portfolioImg11,
    category: "Web/App Dev",
    title: "KangTukang",
    description:
      "KangTukang is a builder booking application. Its main feature is the search for the nearest builder from the customer's location, utilizing the Google Maps API obtained from the customer's and bulider's device coordinates.",
    technologies: ["Flutter", "Go", "MySQL", "Google Maps API", "Google Cloud Compute Engine"],
    siteUrl: "",
  },
  {
    id: "10",
    imgUrl: portfolioImg10,
    category: "ML/App",
    title: "Trascan",
    description:
      "Trascan application utilizes direct scanning technology to differentiate trash types. Users can scan trash and the application will determine if it's organic or inorganic.",
    technologies: ["Python", "Tensorflow", "Keras", "Node.js", "Firebase", "Google Cloud"],
    siteUrl: "https://github.com/capstone-C23-PC682",
  },
  {
    id: "09",
    imgUrl: portfolioImg09,
    category: "Web/App Dev",
    title: "Bagikuen - File Sharing Website",
    description:
    "Bagikeun is a file sharing website that allows users to share their files with their friends through links or email.",
    technologies: ["Node.js", "MongoDB", "Firebase", "SMTP"],
    siteUrl: "https://bagikeun-file-sharing.vercel.app",
  },
  {
    id: "08",
    imgUrl: portfolioImg08,
    category: "Web/App Dev",
    title: "Notes Online Website",
    description:
      "Notes is a website that users can use to write their notes. In this website, users must log in using their Google account.",
    technologies: ["Node.js", "Passport.js", "MongoDB"],
    siteUrl: "https://notes-website-one.vercel.app",
  },
  {
    id: "07",
    imgUrl: portfolioImg07,
    category: "ML",
    title: "Klasifikasi Gambar CNN - Batu Gunting Kertas",
    description:
      "Encompassing the classification of hand gestures in alignment with the rock-paper-scissors game patterns, this employs a Convolutional Neural Network for the precise categorization of hand gestures.",
    technologies: ["Python", "Tensorflow", "Keras", "Numpy"],
    siteUrl: "https://colab.research.google.com/drive/1GfRLE9NpsmEXlYrQqR0Zxl2mr3XtS-S9?usp=sharing",
  },
  {
    id: "06",
    imgUrl: portfolioImg06,
    category: "UI/UX",
    title: "Schedar",
    description:
    "Schedar is an e-commerce platform that focuses on selling high-quality fashion products, accessories, and electronics. With a wide range of continually updated product selections, we aim to meet your needs with the best products from various leading brands.",
    technologies: ["Canva", "Figma"],
    siteUrl: "https://www.figma.com/file/HYhtKl0ZX4lvLAewrXt20Y/Schedar-(Tugas-IMK)?type=design&node-id=0%3A1&mode=design&t=4NzXqKiQ7lFqxvMp-1",
  },
  {
    id: "05",
    imgUrl: portfolioImg05,
    category: "UI/UX",
    title: "Decix Traveler",
    description:
    "Decix Traveler is a company profile website designed to provide information about the services and products offered by the Decix Traveler company.",
    technologies: ["Figma"],
    siteUrl: "https://www.figma.com/file/BjGkLCuHj8peXNXDpqQ66w/Decix-Traveler?type=design&node-id=0%3A1&mode=design&t=wSdjtkAZS0UPI6LV-1",
  },
  {
    id: "04",
    imgUrl: portfolioImg04,
    category: "UI/UX",
    title: "E-Kantin UBJ",
    description:
      "E-Kantin UBJ is an application for the university canteen of Bhayangkara University Jakarta Raya. This application is used for ordering food and beverages at the canteen of Bhayangkara University Jakarta Raya.",
    technologies: ["Canva", "Figma"],
    siteUrl: "https://www.figma.com/file/xLIq365VdmnhBphHObZKsf/E-Kantin-(Tugas-APSI)?type=design&node-id=0%3A1&mode=design&t=KrLU9gYPbY5gXNdj-1",
  },
  {
    id: "03",
    imgUrl: portfolioImg03,
    category: "Web/App Dev",
    title: "Atria Batik",
    description:
      "A batik sales website designed to provide a comprehensive platform for the owner of Atria Batik store, enabling them to closely track incoming orders, and manage their inventory. While customers have the delightful opportunity to browse through the collection of batik products and place their orders for them.",
    technologies: ["Laravel", "Bootstrap", "MySQL"],
    siteUrl: "",
  },
  {
    id: "02",
    imgUrl: portfolioImg02,
    category: "Web/App Dev",
    title: "Blog Posts",
    description:
      "A blog website that allows users to create, publish, edit, and delete their own blog posts, giving them full control over their content.",
    technologies: ["Laravel", "Bootstrap", "MySQL"],
    siteUrl: "",
  },
  {
    id: "01",
    imgUrl: portfolioImg01,
    category: "Web/App Dev",
    title: "SD Jaya Bekasi",
    description:
      "A school management website that allows the management of student, teacher, subject, and grade data. Developed using pure PHP programming language and utilizing a MySQL database.",
    technologies: ["PHP", "Mysql"],
    siteUrl: "",
  },
];

export default portfolios;
